import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import ReturnsMenu from './components/Returns/ReturnsMenu';
import store from 'store-js';

function Returns() {
  const currentTab = store.get('SalsifyDisplayNameList') || 0;
  const [selected, setSelected] = useState(currentTab);
  store.set('SalsifyDisplayNameList', selected);
  const handleTabChange = useCallback(
      (selectedTabIndex) => setSelected(selectedTabIndex),
      [],
  );

  const tabs = [
    {
      id: "Returns",
      title: "Returns",
      content: "Returns",
      page: <ReturnsMenu />,
      panelID: "Returns",
    },
  ];

  return (
    <Page breadcrumbs={[{ url: "/" }]} title={tabs[selected].title} fullWidth>
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}

export default Returns;
